import { useEffect } from "react";
import type { FC } from "react";
import { Link as RouterLink, useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import {
  LoginAmplify,
  LoginAuth0,
  LoginFirebase,
  LoginJWT,
} from "src/components/authentication/login";
import Logo from "src/components/Logo";
import AuthBanner from "src/components/authentication/AuthBanner";
import useAuth from "src/hooks/useAuth";
import gtm from "src/lib/gtm";
import UEHLogo from "../../../components/UEHLogo";
// import PSCLoginJWT from "src/components/authentication/login/PSCLoginJWT";

const platformIcons = {
  Amplify: "/static/icons/amplify.svg",
  Auth0: "/static/icons/auth0.svg",
  Firebase: "/static/icons/firebase.svg",
  JWT: "/static/icons/jwt.svg",
  Logo: "/static/images/logos/neu.png",
};

const Login: FC = () => {
  const { platform } = useAuth() as any;
  const pathLocation = useLocation();
  console.log(platform);

  useEffect(() => {
    gtm.push({ event: "page_view" });
  }, []);

  return (
    <>
      <Helmet>
        <title>Đăng nhập | NEU</title>
      </Helmet>
      <Grid container>
        <Grid
          item
          md={6}
          lg={8}
          sx={{
            display: { xs: "none", sm: "none", md: "block", lg: "block" },
          }}
        >
          <Box
            component="img"
            src="/static/images/Carousel/bg_lg.jpg"
            alt=""
            style={{ objectFit: "cover" }}
            width={"100%"}
            height={"100%"}
          ></Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          {" "}
          <Box
            sx={{
              backgroundColor: "background.default",
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
            }}
          >
            {/* <AuthBanner /> */}
            <Container maxWidth="sm" sx={{ pt: "15px" }}>
              {/* <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 8
            }}
          >
            <RouterLink to="/">
              <UEHLogo
                sx={{
                  height: 40,
                  width: 40
                }}
              />
            </RouterLink>
          </Box> */}
              <RouterLink to="/">
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                    "& > img": {
                      width: "100px",
                    },
                  }}
                >
                  <img alt="Auth platform" src={platformIcons.Logo} />
                </Box>
              </RouterLink>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  mb: 2,
                }}
              >
                <Typography textAlign={"center"} color="textPrimary" gutterBottom variant="h5">
                  ĐẠI HỌC KINH TẾ QUỐC DÂN
                </Typography>
                {/* <Typography color="textPrimary" gutterBottom variant="h5">
                  CỔNG THÔNG TIN SINH VIÊN
                </Typography> */}
              </Box>
              <Card>
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    p: 4,
                  }}
                >
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 3,
                    }}
                  >
                    <div>
                      <Typography color="#0065CA" gutterBottom variant="h4">
                        ĐĂNG NHẬP
                      </Typography>
                      <Typography color="textSecondary" variant="body2">
                        Cổng quản lý giảng đường
                      </Typography>
                    </div>
                    {/* <Box
                  sx={{
                    height: 32,
                    '& > img': {
                      maxHeight: '100%',
                      width: 'auto'
                    }
                  }}
                >
                  <img
                    alt="Auth platform"
                    src={platformIcons[platform]}
                  />
                </Box> */}
                  </Box>
                  <Box
                    sx={{
                      flexGrow: 1,
                      mt: 1,
                    }}
                  >
                    {platform === "Amplify" && <LoginAmplify />}
                    {platform === "Auth0" && <LoginAuth0 />}
                    {platform === "Firebase" && <LoginFirebase />}
                    {!pathLocation.pathname.includes("loginpsc") &&
                      platform === "JWT" && <LoginJWT />}
                    {/* {pathLocation.pathname.includes("loginpsc") &&
                      platform === "JWT" && <PSCLoginJWT />} */}
                  </Box>
                  <Divider sx={{ my: 3 }} />
                  {/* {platform === "JWT" && (
                    <Link
                      color="textSecondary"
                      component={RouterLink}
                      // sx={{ mt: 1 }}
                      to="/authentication/password-recovery"
                      variant="body2"
                    >
                      Quên mật khẩu
                    </Link>
                  )} */}
                </CardContent>
              </Card>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  mt: 3,
                }}
              >
                <Typography color="textSecondary" variant="caption">
                  All Rights Reserved Developed by{" "}
                  <a href="https://psctelecom.com.vn/" target="blank">
                    <img src="/static/Logo_PSC_white.png" />
                  </a>
                </Typography>
              </Box>
            </Container>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Login;
